import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import React, { useState } from 'react';
import { FormikProps } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { typesEventFormData } from 'system/pages/type-events/list/types';

interface Props {
  filterTypesEventForm: FormikProps<typesEventFormData>;
}

const TypesEventFilter = ({ filterTypesEventForm }: Props): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);
  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-townhalls-content"
          id="panel-townhalls-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={filterTypesEventForm.handleSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Codice"
                  label="Codice"
                  id="code"
                  name="code"
                  value={filterTypesEventForm.values.code}
                  onChange={filterTypesEventForm.handleChange}
                  helperText={filterTypesEventForm.errors.code}
                  error={
                    Boolean(filterTypesEventForm.errors.code) && filterTypesEventForm.touched.code
                  }
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '5',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Descrizione zona"
                  label="Descrizione"
                  id="description"
                  value={filterTypesEventForm.values.description}
                  error={
                    Boolean(filterTypesEventForm.errors.description) &&
                    filterTypesEventForm.touched.description
                  }
                  helperText={filterTypesEventForm.errors.description}
                  onChange={filterTypesEventForm.handleChange}
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '100',
                  }}
                />
              </Grid>
              <Grid item xs>
                <PmiButton variant="contained" color="secondary" type="submit">
                  Cerca
                </PmiButton>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

TypesEventFilter.displayName = 'Types Event filter form component';
export default TypesEventFilter;
